/**
 * 텍스트를 클립보드에 복사
 * - Clipboard API 우선 사용, 미지원 시 execCommand fallback
 *
 * @example
 * const ok = await copyToClipboard('복사할 텍스트')
 * if (ok) toast.success('복사되었습니다')
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  // Clipboard API 지원 시
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      // 권한 거부 등 — fallback으로 진행
    }
  }

  // fallback: execCommand
  try {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.left = '-9999px'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()
    const ok = document.execCommand('copy')
    document.body.removeChild(textarea)
    return ok
  } catch {
    return false
  }
}
